"use client"

import DynamicLink from "@/app/(site)/_components/Molecules/Link"
import ButtonGroup from "@/app/(site)/_components/SanityGroups/ButtonGroup"
import SubHeadingGroup from "@/app/(site)/_components/SanityGroups/SubHeadingGroup"
import { type TextColorType } from "@/gc-sanity-types"
import {
    type ButtonLinkElementType,
    type SubHeadingGroupType
} from "@/types/gc-modules-types"
import { clsx } from "@/src/utils/clsx"

interface SubHeadingAndButtonsProps {
    subHeadingGroup?: SubHeadingGroupType
    buttonGroup?: { buttons: ButtonLinkElementType[] }
    className?: string
    wrapSubHeadingWithLink?: boolean
    subHeadingLinkHref?: string
    textColor?: TextColorType
}

export default function SubHeadingAndButtons({
    subHeadingGroup,
    buttonGroup,
    className,
    wrapSubHeadingWithLink = false,
    subHeadingLinkHref,
    textColor
}: SubHeadingAndButtonsProps) {
    if (
        !subHeadingGroup?.subHeadingElement &&
        (!buttonGroup ||
            !Array.isArray(buttonGroup.buttons) ||
            buttonGroup.buttons.length === 0)
    )
        return null

    return (
        <div className={clsx("flex flex-col", className)}>
            {subHeadingGroup?.subHeadingElement &&
                (wrapSubHeadingWithLink && subHeadingLinkHref ? (
                    <DynamicLink
                        href={subHeadingLinkHref}
                        prefetch={false}
                        className="mb-16 inline-block w-fit max-w-[542px] sm:mb-24"
                    >
                        <SubHeadingGroup
                            subHeadingElement={subHeadingGroup.subHeadingElement}
                            textColor={textColor || "text-main-black"}
                            className="max-w-[542px]"
                        />
                    </DynamicLink>
                ) : (
                    <SubHeadingGroup
                        subHeadingElement={subHeadingGroup.subHeadingElement}
                        textColor={textColor || "text-main-black"}
                        className={clsx("max-w-[542px]", buttonGroup && "mb-16 sm:mb-24")}
                    />
                ))}
            {buttonGroup &&
                Array.isArray(buttonGroup.buttons) &&
                buttonGroup.buttons.length > 0 && (
                    <ButtonGroup
                        buttons={buttonGroup.buttons}
                        className="flex flex-wrap items-center gap-16"
                    />
                )}
        </div>
    )
}
